import { render, staticRenderFns } from "./caseStudies.vue?vue&type=template&id=37dd8304&"
import script from "./caseStudies.vue?vue&type=script&lang=js&"
export * from "./caseStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports